import React, { useEffect, useState } from "react";
import PageChanger from "../../Helpers/Components/Pagination";
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";
import Handler from "../../Helpers/Components/Handler";
import moment from "moment";
import { toast } from "react-toastify";
import * as FileSaver from "file-saver";
import XLSX from 'sheetjs-style';
import Select from 'react-select'

const Report = () => {
    const { pageNo } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [cart, setCart] = useState(localStorage.getItem('filter'));
    const [next, setNext] = useState(false)
    const [reportDetails, setReportDetails] = useState([])
    const [date, setDate] = useState(cart ? JSON?.parse(cart)?.date ? JSON?.parse(cart)?.date : [new Date()] : [new Date()])
    const setPageNo = (value) => navigate(`/daily/report/${value}`)
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [count, setCount] = useState(cart ? JSON?.parse(cart)?.count ? JSON?.parse(cart)?.count : 10 : 10)
    const getDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'POST', url: `/booking/daily/report/${pageNo}?count=${count || 10}`, data: { from: date?.length ? moment(new Date(date[0])).format('DD-MM-YYYY') : moment(new Date()).format('DD-MM-YYYY'), to: date?.length > 1 ? moment(new Date(date[1])).format('DD-MM-YYYY') : moment(new Date(date[0])).format('DD-MM-YYYY') } })
        if (response.success) {
            setReportDetails(response.data?.list)
            setNext(response.data?.next)
        } else {
            setReportDetails([])
            setNext(false)
        }
        setLoading(false)
    }
    const dateFormat = (date) => {
        const splitDate = date?.split("-")
        if (splitDate?.length > 2) {
            return splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0]
        } else {
            return date
        }
    }
    const exportFile = async () => {
        setLoading(true)
        const response = await Handler({ method: 'POST', url: `/booking/daily/report/${pageNo}`, data: { download: true, from: date?.length ? moment(new Date(date[0])).format('DD-MM-YYYY') : moment(new Date()).format('DD-MM-YYYY'), to: date?.length > 1 ? moment(new Date(date[1])).format('DD-MM-YYYY') : moment(new Date(date[0])).format('DD-MM-YYYY') } })
        if (response.success) {
            const downloadFile = response.data?.list?.length ?
                response.data?.list?.map(element => {
                    return {
                        'Date': dateFormat(element.date),
                        'Booked': element.booked,
                        'Ongoing': element.ongoing,
                        'Pending': element.pending,
                        'Completed': element.completed,
                        'Verified': element.verified,
                        'Cancelled': element.cancelled,
                        'No. of Days': element.totalDays,
                        'No. of Bookings': element.totalBookings
                    }
                })
                : []
            const ws = XLSX?.utils?.json_to_sheet(downloadFile);
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "Report" + fileExtension);
            setLoading(false)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }
    }
    useEffect(() => {
        getDetails()
    }, [date, pageNo, count])
    const setItem = (name, value) => {
        const existing = localStorage.getItem('filter');
        let oldData = existing ? JSON.parse(existing) : {};
        oldData[name] = value || "";
        localStorage.setItem('filter', JSON.stringify(oldData));
    };
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Daily Report</h5>
            <div className="layout-card mt-4">
                <div className="row gap-3 align-items-center justify-content-between">
                    <div className="col-lg-3">
                    <div className=' datepicker-top'>  <DatePicker
                            range
                            format="DD-MM-YYYY"
                            onChange={(e) => { setPageNo(1); setDate(e); setItem('date', e) }}
                            value={date}
                        /></div>
                    </div>
                    <div className="col-lg-3 text-end">
                        <button onClick={exportFile} className="link-btn"><i className="fa-solid fa-download fs-5"></i></button>
                    </div>
                </div>
                <div className="my-3 fs-5 fw-medium"></div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom text-center" >
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Booked</th>
                                <th>Ongoing</th>
                                <th>Pending</th>
                                <th>Completed</th>
                                <th>Verified</th>
                                <th>Cancelled</th>
                                <th>No. of Days </th>
                                <th>No. of Bookings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (reportDetails && reportDetails?.length !== 0 ? reportDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row text-center`}>
                                            <td>{(10 * (Number(pageNo) - 1)) + (key + 1)}</td>
                                            <td>{value?.date ? dateFormat(value?.date) : ''}</td>
                                            <td>{value?.booked || 0}</td>
                                            <td>{value?.ongoing || 0}</td>
                                            <td>{value?.pending || 0}</td>
                                            <td>{value?.completed || 0}</td>
                                            <td>{value?.verified || 0}</td>
                                            <td>{value?.cancelled || 0}</td>
                                            <td>{value?.totalDays || 0}</td>
                                            <td>{value?.totalBookings || 0}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={10}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={10} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                   <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setCount(Number(selectedoption?.value))
                            setItem('count', 10)
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={count ? {label: count, value: count} : {label: 10, value: 10}}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='daily/report' />
            </div>
        </React.Fragment>
    )
}

export default Report;